import { omit, some } from 'lodash'
import { nullifiedThemeEmptyField } from '@/vuex/modules/presentation/theme.module'
import { DEFAULT_THEME_ATTRIBUTES } from '@/constant/theme'

const _getters = {
  canViewThemeGallery: (_, __, ___, rootGetters) => {
    return rootGetters['themeModule/canViewThemeGallery']
  },
  presentationTheme: (_, __, ___, rootGetters) => {
    const theme = rootGetters['themeModule/currentPresentationTheme']
    // We doesn't need the backgroundImage and baseColour because it will be rendered in another layer
    return omit(theme, ['backgroundImage', 'baseColour', 'visibility'])
  },
  // Slide depends on the theme except the backgroundImage, baseColour and visibility
  slides: (_, getters, rootState) => {
    const { slides } = rootState?.presentation
    const { presentationTheme } = getters
    if (getters.canViewThemeGallery) {
      return slides.map((slide) => {
        return {
          ...presentationTheme,
          ...nullifiedThemeEmptyField(slide),
        }
      })
    }

    return slides.map((slide) => {
      return {
        ...DEFAULT_THEME_ATTRIBUTES,
        ...nullifiedThemeEmptyField(slide),
      }
    })
  },
  slideActive: (_, getters, rootState) => {
    const slideActive = rootState?.slideActive
    const { presentationTheme } = getters

    if (getters.canViewThemeGallery) {
      return {
        ...presentationTheme,
        ...nullifiedThemeEmptyField(slideActive),
      }
    }

    return {
      ...DEFAULT_THEME_ATTRIBUTES,
      ...nullifiedThemeEmptyField(slideActive),
    }
  },
  // This one doesn't use the omitted version of the theme
  // Only use for calculating this.boxWaitBg in QuizSlideContent.vue
  slideActiveBaseColour: (_, getters, rootState, rootGetters) => {
    const { baseColour } = rootState?.slideActive
    const presentationTheme = rootGetters['themeModule/currentPresentationTheme']

    if (getters.canViewThemeGallery) {
      return baseColour || presentationTheme.baseColour
    }

    return baseColour
  },
  hasCustomisedSlide: (_, __, rootState) => {
    const { slides } = rootState?.presentation
    return some(slides, (item) => {
      const slide = nullifiedThemeEmptyField(item)
      return slide.textColour || slide.baseColour || slide.backgroundImage
    })
  },
  defaultSlideConfig: (_, getters) => {
    if (getters.canViewThemeGallery) return {}
    return omit(DEFAULT_THEME_ATTRIBUTES, ['backgroundImage'])
  },
  blankStyleSlide: (_, getters) => {
    if (getters.canViewThemeGallery) {
      return {
        textColour: '',
        baseColour: '',
        visibility: -1,
        backgroundImage: null,
      }
    }
    return {
      textColour: '#313131',
      baseColour: '#ffffff',
      visibility: 20,
      backgroundImage: null,
    }
  },
}

export default {
  namespaced: true,
  getters: _getters,
}
